import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import InputCustom from '@pages/components/InputCustom';
import { ArraySelect, InputArraySelect, InputKeySelect } from '@pages/components/InputSelect';
import { ButtonContainer } from '@pages/reusable-components/styled-components';
import { paymentIntervalsObject } from '../../../../../constants';

export default function DealInfoTab({
  deal: initialDeal,
  dealErrors = {},
  dealChecksheet = {},
  deliveredStatuses = [],
  dealStatuses = {},
  updateDeal,
  clearMenus,
  defaulter,
  expired,
  getDocument,
  setTransitModal,
}) {
  const [deal, setDeal] = useState({});

  useEffect(() => {
    if (initialDeal) {
      let idx = Object.values(paymentIntervalsObject).findIndex(
        ({ payment_frequency_interval, payment_frequency }) => {
          return (
            initialDeal.payment_frequency === payment_frequency &&
            initialDeal.payment_frequency_interval === payment_frequency_interval
          );
        }
      );
      if (idx >= 0) {
        initialDeal.payment_interval = Object.keys(paymentIntervalsObject)[idx];
      }
      setDeal(initialDeal);
    }
  }, [initialDeal]);

  const selectNewInterval = (value) => {
    setDeal({ ...deal, payment_interval: value, ...paymentIntervalsObject[value] });
  };
  const renderChecklist = () => (
    <Col lg={3} md={4} sm={12}>
      <h2 className="text-center mt-5">Deal Check List</h2>
      {Object.keys(dealChecksheet).map((key1, idx) => (
        <div key={idx}>
          {Object.keys(dealChecksheet[key1]).map((key2) => (
            <Row className="mt-3" key={key2}>
              <Col md={5}>
                <label className="form-control-label">{dealChecksheet[key1][key2]}</label>
              </Col>
              <Col md={5} className="d-flex" style={{ gap: '8px' }}>
                <label className="custom-toggle">
                  <input
                    type="checkbox"
                    checked={deal?.checksheet?.[key2] === 1}
                    onChange={() => {
                      setDeal((prev) => ({
                        ...prev,
                        checksheet: {
                          ...prev.checksheet,
                          [key2]: prev.checksheet?.[key2] === 1 ? 0 : 1,
                        },
                      }));
                    }}
                  />
                  <span className="custom-toggle-slider rounded-circle" />
                </label>
                <span
                  className="font-weight-600"
                  style={{ color: deal?.checksheet?.[key2] === 1 ? '#ec6409' : '', fontSize: 14 }}
                >
                  {deal?.checksheet?.[key2] === 1 ? 'Yes' : 'No'}
                </span>
              </Col>
            </Row>
          ))}
        </div>
      ))}
    </Col>
  );
  const renderInfoSection = () => (
    <Col lg={6} md={8} sm={12}>
      <h2 className="text-center mt-5">Deal Info</h2>
      <Row>
        <Col md={6}>
          <Col sm={12}>
            <ArraySelect
              label="Interval"
              value={deal?.payment_interval || ''}
              options={Object.keys(paymentIntervalsObject)}
              valueKey={`id`}
              labelKey={`name`}
              onChange={(e) => selectNewInterval(e.target.value)}
              invalid={!!dealErrors.payment_interval}
              errorMessage={dealErrors.payment_interval}
            />
          </Col>
          <Col sm={12}>
            <InputCustom
              newLabel="Term"
              value={deal?.term || ''}
              readOnly
              onChange={(e) => setDeal({ ...deal, term: e.target.value })}
            />
          </Col>
          <Col sm={12}>
            <InputCustom
              type="number"
              newLabel="Delivery Fee"
              value={deal?.delivery_fee || ''}
              onChange={(e) => setDeal({ ...deal, delivery_fee: e.target.value })}
            />
          </Col>
          <Col sm={12}>
            <InputCustom
              newLabel="28 day mileage allowance"
              value={deal?.annual_mileage || ''}
              onChange={(e) => setDeal({ ...deal, annual_mileage: e.target.value })}
            />
          </Col>
          <Col sm={12}>
            <InputCustom
              newLabel="Expected profit"
              value={deal?.expected_profit || ''}
              readOnly
              onChange={(e) => setDeal({ ...deal, expected_profit: e.target.value })}
            />
          </Col>
          <Col sm={12}>
            <InputCustom
              newLabel="End payment"
              value={deal?.end_payment || ''}
              onChange={(e) => setDeal({ ...deal, end_payment: e.target.value })}
            />
          </Col>
        </Col>
        <Col md={6}>
          <Col sm={12}>
            <InputCustom
              newLabel="Rental"
              value={deal?.monthly_payment || ''}
              readOnly
              onChange={(e) => setDeal({ ...deal, monthly_payment: e.target.value })}
            />
          </Col>

          <Col sm={12}>
            <InputCustom
              newLabel="Initial payment"
              value={deal?.initial_payment || ''}
              readOnly
              onChange={(e) => setDeal({ ...deal, initial_payment: e.target.value })}
            />
          </Col>
          <Col sm={12}>
            <InputCustom type="number" readOnly={true} newLabel="Admin Fee" value={150} />
          </Col>
          <Col sm={12}>
            <InputCustom
              type="number"
              newLabel="First rental"
              value={deal?.monthly_payment || ''}
              readOnly
            />
          </Col>
          <Col sm={12}>
            <InputCustom
              type="number"
              newLabel="Total up front Fee"
              value={deal?.monthly_payment + deal?.initial_payment + 150}
              readOnly
            />
          </Col>
        </Col>
      </Row>
    </Col>
  );

  const renderRightColumn = () => (
    <Col lg={3} sm={12} md={12}>
      <Row className="mt-5 mb-2">
        <Col md={5} sm={12}>
          <h4>Deal Status</h4>
        </Col>
        <Col md={7} sm={12}>
          <ButtonContainer onClick={() => getDocument(deal.id)}>Download</ButtonContainer>
        </Col>
      </Row>
      <Col sm={12}>
        <InputKeySelect
          newLabel="Deal status"
          value={deal?.deal_status || ''}
          onChange={(e) => setDeal({ ...deal, deal_status: e.target.value })}
          options={dealStatuses}
          defaultOption
        />
      </Col>
      <Col sm={12}>
        <InputCustom
          type="date"
          newLabel="Deal date"
          value={deal?.deal_date || ''}
          onChange={(e) => setDeal({ ...deal, deal_date: e.target.value })}
        />
      </Col>
      <Col sm={12}>
        <InputCustom
          type="date"
          newLabel="Delivery date"
          value={deal?.delivery_date || ''}
          onChange={(e) => setDeal({ ...deal, delivery_date: e.target.value })}
          invalid={!!dealErrors.delivery_date}
          errorMessage={dealErrors.delivery_date}
        />
      </Col>
      <Col sm={12}>
        <InputCustom
          type="date"
          newLabel="Canceled date"
          value={deal?.canceled_at || ''}
          onChange={(e) => setDeal({ ...deal, canceled_at: e.target.value })}
        />
      </Col>
      <Col sm={12}>
        <div className="d-flex flex-row justify-content-end mt-5">
          {deliveredStatuses.includes(deal?.deal_status) && (
            <ButtonContainer
              onClick={() =>
                setTransitModal({
                  show: true,
                  header: 'Are you sure you want to add customer as defaulter?',
                  body: 'Proceeding with this operation will turn vehicle available!',
                  onClick: () => defaulter(),
                })
              }
            >
              Defaulter
            </ButtonContainer>
          )}
          {deliveredStatuses[0] === deal?.deal_status && (
            <ButtonContainer
              onClick={() =>
                setTransitModal({
                  show: true,
                  header: 'Are you sure you want to mark as expired?',
                  body: 'Proceeding with this operation will mark deal as expired and vehicle available!',
                  onClick: () => expired(),
                })
              }
            >
              Expired
            </ButtonContainer>
          )}
        </div>
      </Col>
    </Col>
  );

  return (
    <Card>
      <CardBody>
        <Row className="mt-4">
          {renderChecklist()}
          {renderInfoSection()}
          {renderRightColumn()}
        </Row>
        <div className="d-flex flex-row justify-content-center mt-5">
          <ButtonContainer
            onClick={() => {
              clearMenus();
            }}
          >
            Cancel
          </ButtonContainer>
          <ButtonContainer reverse onClick={() => updateDeal({ dealData: deal })}>
            Update
          </ButtonContainer>
        </div>
      </CardBody>
    </Card>
  );
}
